import { HostUpdater } from "./HostUpdater.js";
const hostUpdatersByObservable = new WeakMap();
export function track(host, observable) {
    if (!observable) {
        return (observable) => {
            return track(host, observable);
        };
    }
    const controller = new HostUpdater(host, observable);
    hostUpdatersByObservable.set(observable, controller);
    return observable;
}
export function untrack(host, observable) {
    if (!observable) {
        return (observable) => {
            return untrack(host, observable);
        };
    }
    const controller = hostUpdatersByObservable.get(observable);
    if (controller) {
        controller.subscription.unsubscribe();
        hostUpdatersByObservable.delete(observable);
    }
    return observable;
}
